module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-theme-config-container",
    class: {
      'is-closed': _vm.opened
    }
  }, [_c('div', {
    staticClass: "u-theme-config-panel",
    class: {
      'open': _vm.opened
    }
  }, [_c('div', {
    staticClass: "u-theme-content"
  }, [_c('div', {
    staticClass: "center-progress"
  }, [_c('progress-bar', {
    ref: "progressbar",
    attrs: {
      "pclass": "progress2",
      "height": "6px",
      "color": "#23b7e5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50158b4a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/ChangeStatus.vue
// module id = 784
// module chunks = 2